import { StyleSheet } from 'react-native';
import { Colors } from '@shared/styles';

const linkPreviewHeight = 78;

export const Styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: Colors.gray.border,
    height: linkPreviewHeight,
  },
  image: {
    width: linkPreviewHeight - 2, // - 2 * border width
    height: linkPreviewHeight - 2, // - 2 * border width
  },
  overflowHidden: { overflow: 'hidden' },
});
